'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link } from 'react-router';

var NewMediumWeiBoComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NewMediumWeiBoComponent, _Component);

  function NewMediumWeiBoComponent() {
    (0, _classCallCheck3.default)(this, NewMediumWeiBoComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(NewMediumWeiBoComponent).call(this));
  }

  (0, _createClass3.default)(NewMediumWeiBoComponent, [{
    key: 'render',
    value: function render() {
      var styles = require('./NewMediumWeiBoComponent.scss');
      var data = this.props.data;

      return _react2.default.createElement(
        'div',
        null,
        data instanceof Array && data.length > 0 ? data.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { key: index, className: styles.new_right_wb },
            _react2.default.createElement('img', { src: item.authorImg, alt: '', className: styles.icon_tou }),
            _react2.default.createElement(
              'div',
              { className: styles.icon_name },
              _react2.default.createElement(
                'p',
                { className: styles.span1 },
                item.author
              ),
              _react2.default.createElement(
                'p',
                { className: styles.span2 },
                item.authorWork
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.nei_box },
              _react2.default.createElement('img', { src: item.productImg, alt: '', className: styles.img_banner }),
              _react2.default.createElement(
                'div',
                { className: styles.nei_right },
                _react2.default.createElement(
                  'p',
                  { className: styles.h1 },
                  item.productHeader
                ),
                _react2.default.createElement(
                  'p',
                  { className: styles.h2 },
                  item.productIntro
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.date },
                  _react2.default.createElement(
                    'i',
                    null,
                    _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg6.png', alt: '' })
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    item.date
                  )
                ),
                _react2.default.createElement(
                  'p',
                  { className: styles.fans },
                  '粉丝数：' + item.fansNum
                )
              )
            ),
            _react2.default.createElement('div', { className: 'clear' })
          );
        }) : ''
      );
    }
  }]);
  return NewMediumWeiBoComponent;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.array
}, _temp);
exports.default = NewMediumWeiBoComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewMediumWeiBoComponent/NewMediumWeiBoComponent.js
 ** module id = 1379
 ** module chunks = 0
 **/